import FanBookmarkFeedDetailsComponent from "./FanBookmarkFeedDetailsComponent";
export default FanBookmarkFeedDetailsComponent;
